export default "__VITE_ASSET__C6N5jIoS__"